import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'

// Stylesheet order matches the Foundation site's, and matters: the icon font, then
// Bootstrap, then Swiper and animate.css, then the app sheet — which loads the design
// system and this app's token overrides after it.
import '@kkf/design/assets/fonts/flaticon_charitics.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'swiper/css/bundle'
import 'animate.css'
import './styles/index.scss'

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
